import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useHeaderPopup } from './useHeaderPopup';

export const useRoute = () => {
  const location = useLocation();
  const pathName = location.pathname.substring(1);
  const { openModalByRoute, closeAllModals } = useHeaderPopup();

  const prevPathnameRef = useRef<string>();

  useEffect(() => {
    if (prevPathnameRef.current === pathName) {
      return;
    }

    prevPathnameRef.current = pathName;

    if (pathName === '/' || pathName === '') {
      closeAllModals();
      return;
    }

    const splitPath = pathName.split('/');
    const pageId = splitPath[0].toLowerCase();

    openModalByRoute(pageId, splitPath);
  }, [pathName]);

  useEffect(() => {
    return () => {
      prevPathnameRef.current = undefined;
    };
  }, []);
};
